module.exports = __webpack_public_path__ + "img/zl.7aafcddf.png";